import React from 'react'
import {
  AlertTriangle, Activity, LayoutDashboard, TrendingUp, Users, Headphones,
  Building2, Wrench, Settings, ChevronRight, ChevronDown, Search, Bell,
  Moon, Sun, Circle, Check, X, Package, GitBranch, Zap, Clock, Filter,
  Plus, MoreHorizontal, ArrowRight, ArrowUpRight, Flame, Hash, Shield,
  Database, Mail, ExternalLink, List, Grid3x3, Inbox, Cpu, CreditCard,
  DollarSign, UserPlus, TrendingDown, Key, Play, Pause, CircleDot,
  RotateCcw, FileText, Pencil, Copy, Eye, EyeOff, RefreshCw,
  Globe, Monitor, Smartphone,
  type LucideProps,
} from 'lucide-react'

const ICONS: Record<string, React.ComponentType<LucideProps>> = {
  'alert-triangle': AlertTriangle,
  'activity': Activity,
  'layout-dashboard': LayoutDashboard,
  'trending-up': TrendingUp,
  'users': Users,
  'headphones': Headphones,
  'building-2': Building2,
  'wrench': Wrench,
  'settings': Settings,
  'chevron-right': ChevronRight,
  'chevron-down': ChevronDown,
  'search': Search,
  'bell': Bell,
  'moon': Moon,
  'sun': Sun,
  'circle': Circle,
  'check': Check,
  'x': X,
  'package': Package,
  'git-branch': GitBranch,
  'zap': Zap,
  'clock': Clock,
  'filter': Filter,
  'plus': Plus,
  'more-horizontal': MoreHorizontal,
  'arrow-right': ArrowRight,
  'arrow-up-right': ArrowUpRight,
  'flame': Flame,
  'hash': Hash,
  'shield': Shield,
  'database': Database,
  'mail': Mail,
  'external-link': ExternalLink,
  'list': List,
  'grid': Grid3x3,
  'inbox': Inbox,
  'cpu': Cpu,
  'credit-card': CreditCard,
  'dollar-sign': DollarSign,
  'user-plus': UserPlus,
  'trend-down': TrendingDown,
  'key': Key,
  'play': Play,
  'pause': Pause,
  'circle-dot': CircleDot,
  'pulse': Activity,
  'rotate-ccw': RotateCcw,
  'file-text': FileText,
  'pencil': Pencil,
  'copy': Copy,
  'eye': Eye,
  'eye-off': EyeOff,
  'refresh-cw': RefreshCw,
  'globe': Globe,
  'monitor': Monitor,
  'smartphone': Smartphone,
}

export type IconName = keyof typeof ICONS | string

export function Icon({
  name, size = 14, className = '', style,
}: { name: IconName; size?: number; className?: string; style?: React.CSSProperties }) {
  const Cmp = ICONS[name]
  if (!Cmp) {
    return <span className={`ic ${className}`} style={{ width: size, height: size, ...style }} />
  }
  return <Cmp size={size} strokeWidth={1.75} className={`ic ${className}`} style={style} aria-hidden />
}
